import type { SEOScoreSpec } from '../../contentstudio/framework';
import { cn } from '../../lib/cn';

type Props = {
  scores?: SEOScoreSpec[];
};

function scoreColor(score: number) {
  if (score >= 80) return 'text-success-600';
  if (score >= 65) return 'text-warning-600';
  return 'text-error-600';
}

function trendIcon(trend?: string) {
  if (trend === 'up') return '↑';
  if (trend === 'down') return '↓';
  return '→';
}

export function SEOEnginePanel({ scores = [] }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
      {scores.map((s) => (
        <div key={s.analysis} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium text-slate-500">{s.label}</p>
            {s.trend && <span className="text-xs text-slate-400">{trendIcon(s.trend)}</span>}
          </div>
          <p className={cn('mt-1 text-xl font-semibold', scoreColor(s.score))}>{s.score}</p>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div
              className={cn('h-full rounded-full', s.score >= 80 ? 'bg-success-500' : s.score >= 65 ? 'bg-warning-500' : 'bg-error-500')}
              style={{ width: `${s.score}%` }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
